import store from 'store/dist/store.everything.min'

const STORAGE_MAIN_NAME = 'AFTVClient'
const STORAGE_TOKEN = 'AccessToken'
const REFRESH_TOKEN = 'RefreshToken'
const REFRESH_TOKEN_TYPE_CASUAL = 'C'
const REFRESH_TOKEN_TYPE_REGISTERED = 'R'
const SHARE_TOKEN = 'ShareToken'
const APP_INSTALL_ID = 'AppInstallId'
const DEVICE_ID = 'DeviceId'
const NOTIFICATIONS = 'Notifications'

class Storage {
  constructor () {
    this.namespace = store.namespace(STORAGE_MAIN_NAME)
  }

  saveShareToken (shareToken) {
    this.namespace.remove(SHARE_TOKEN)
    this.namespace.set(SHARE_TOKEN, shareToken)
  }

  getShareToken () {
    return null
    // return this.namespace.get(SHARE_TOKEN)
  }

  removeRefreshToken () {
    this.namespace.remove(REFRESH_TOKEN)
  }

  saveRefreshToken (refreshToken, refreshTokenType) {
    this.removeRefreshToken()
    this.namespace.set(REFRESH_TOKEN, `${refreshToken},${refreshTokenType}`)
  }

  getRefreshToken () {
    const tokenValue = this.namespace.get(REFRESH_TOKEN)
    if (!tokenValue) {
      return null
    }
    const tokenParts = tokenValue.split(',')
    return tokenParts[0]
  }

  getRefreshTokenType () {
    const tokenValue = this.namespace.get(REFRESH_TOKEN)
    if (tokenValue) {
      const tokenParts = tokenValue.split(',')
      if (tokenParts.length === 2 &&
          (tokenParts[1] === REFRESH_TOKEN_TYPE_CASUAL || tokenParts[1] === REFRESH_TOKEN_TYPE_REGISTERED)) {
        return tokenParts[1]
      }
    }
    return REFRESH_TOKEN_TYPE_CASUAL
  }

  saveToken (accessToken) {
    this.namespace.remove(STORAGE_TOKEN)
    this.namespace.set(STORAGE_TOKEN, accessToken)
  }

  getToken () {
    return this.namespace.get(STORAGE_TOKEN)
  }

  removeAppInstallId () {
    this.namespace.remove(APP_INSTALL_ID)
  }

  saveAppInstallId (appInstallId) {
    this.removeAppInstallId()
    this.namespace.set(APP_INSTALL_ID, appInstallId)
  }

  getAppInstallId () {
    return this.namespace.get(APP_INSTALL_ID)
  }

  removeDeviceId () {
    this.namespace.remove(DEVICE_ID)
  }

  saveDeviceId (deviceId) {
    this.removeDeviceId()
    this.namespace.set(DEVICE_ID, deviceId)
  }

  getDeviceId () {
    return this.namespace.get(DEVICE_ID)
  }

  enableNotifications (enabled) {
    this.namespace.remove(NOTIFICATIONS)
    this.namespace.set(NOTIFICATIONS, enabled)
  }
  areNotificationsEnabled () {
    const areEnabled = this.namespace.get(NOTIFICATIONS)
    return typeof areEnabled === 'boolean' ? areEnabled : true
  }
}

const storage = new Storage()
export { storage, REFRESH_TOKEN_TYPE_REGISTERED, REFRESH_TOKEN_TYPE_CASUAL }
